const REFERRAL_STORAGE_KEY = 'asetquhub.referralCode';
const REFERRAL_QUERY_PARAM = 'ref';

/**
 * Referral links handed out by the backend look like
 * `https://member.asetquhub.com/?ref=ASQ_01KD5WQY`. The recipient lands here
 * before they have an account, and signing up walks them through a wallet
 * round trip that leaves the page, so the code is persisted rather than kept in
 * component state.
 */
export function captureReferralFromUrl(search: string = window.location.search): void {
  const code = new URLSearchParams(search).get(REFERRAL_QUERY_PARAM)?.trim();
  if (!code) return;

  try {
    localStorage.setItem(REFERRAL_STORAGE_KEY, code);
  } catch {
    // Private mode or blocked storage: sign-up still works, just unattributed.
  }
}

export function getStoredReferral(): string | undefined {
  try {
    return localStorage.getItem(REFERRAL_STORAGE_KEY) ?? undefined;
  } catch {
    return undefined;
  }
}

export function clearStoredReferral(): void {
  try {
    localStorage.removeItem(REFERRAL_STORAGE_KEY);
  } catch {
    // Nothing to clean up if storage is unavailable.
  }
}
